import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import EntryNavLinks from './EntryNavLinks';

import OmeMeetOrgUnitEntryInfoContextProvider from '../../state/omeMeetOrgUnitEntryInfo/OmeMeetOrgUnitEntryInfoContextProvider';
import OmeMeetOrgUnitEntryRosterPermissionsContextProvider from '../../state/omeMeetOrgUnitEntryRosterPermissions/OmeMeetOrgUnitEntryRosterPermissionsContextProvider';
import OmeMeetContextProvider from '../../state/omeMeet/OmeMeetContextProvider';
import OmeMeetEntryContextProvider from '../../state/omeMeetEntry/OmeMeetEntryContextProvider';
import OmeMeetOrgUnitEntryContextProvider from '../../state/omeMeetOrgUnitEntry/OmeMeetOrgUnitEntryContextProvider';
import OmeMeetTeamEntryContextProvider from '../../state/omeMeetTeamEntry/OmeMeetTeamEntryContextProvider';
import OmeMeetTeamEntryFiltersContextProvider from '../../state/omeMeetTeamEntry/OmeMeetTeamEntryFiltersContextProvider';
import OmeMeetOrgUnitEntryPurchaseContextProvider from '../../state/omeMeetOrgUnitEntryPurchase/OmeMeetOrgUnitEntryPurchaseContextProvider';
import OrgUnitAthleteEntryPurchaseContextProvider from '../../state/orgUnitAthleteEntryPurchase/OrgUnitAthleteEntryPurchaseContextProvider';
import OmeMeetOrgUnitAthleteEntryContextProvider from '../../state/omeMeetOrgUnitAthleteEntry/OmeMeetOrgUnitAthleteEntryContextProvider';
import OmeMeetOrgUnitAthleteEntryRosterSelectionContextProvider from '../../state/omeMeetOrgUnitAthleteEntryRosterSelection/OmeMeetOrgUnitAthleteEntryRosterSelectionContextProvider';
import OmeMeetOrgUnitNonAthleteEntryContextProvider from '../../state/omeMeetOrgUnitNonAthleteEntry/OmeMeetOrgUnitNonAthleteEntryContextProvider';
import OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider from '../../state/omeMeetOrgUnitNonAthleteEntryCredentialsSelection/OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider';
import CredentialTypeContextProvider from '../../state/credentialType/CredentialTypeContextProvider';
import OrgGroupContextProvider from '../../state/orgGroup/OrgGroupContextProvider';
import OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider from '../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider';
import OrgUnitAthleteEntryContextIndividualRosterEntryProvider from '../../state/orgUnitAthleteEntry/OrgUnitAthleteEntryIndividualRosterEntryContextProvider';
import OmeMeetOrgUnitAthleteEntryRelayRosterEntryContextProvider from '../../state/omeMeetOrgUnitAthleteEntryRelayRosterEntry/OmeMeetOrgUnitAthleteEntryRelayRosterEntryContextProvider';
import RelayAthleteMeetEventContextProvider from '../../state/relayAthleteMeetEvent/RelayAthleteMeetEventContextProvider';
import RelayAthleteEntryTimeContextProvider from '../../state/relayAthleteEntryTime/RelayAthleteEntryTimeContextProvider';
import OUAdminEntryContextContextProvider from '../../state/ouAdminEntryContextView/OUAdminEntryContextContextProvider';
import EventMeetEventBonusContextProvider from '../../state/eventMeetEventBonus/EventMeetEventBonusContextProvider';
import EventMeetEventContextProvider from '../../state/eventMeetEvent/EventMeetEventContextProvider';
import AthleteEntryContextContextProvider from '../../state/athleteEntryContextView/AthleteEntryContextContextProvider';
import OmeMeetOrgUnitEntryTimesContextProvider from '../../state/omeMeetOrgUnitEntryTimes/OmeMeetOrgUnitEntryTimesContextProvider';
import OmeMeetOrgUnitAthleteEntryAggregateRelayAthleteContextProvider from '../../state/omeMeetOrgUnitAthleteEntryAggregateRelayAthlete/OmeMeetOrgUnitAthleteEntryAggregateRelayAthleteContextProvider';
import OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryContextProvider from '../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntry/OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryContextProvider';
import OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider from '../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection/OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider';
import ApprovedClubsForSecondaryRepContextProvider from '../../state/approvedClubsForSecondaryRep/ApprovedClubsForSecondaryRepContextProvider';
import OmeMeetOrgUnitContactContextProvider from '../../state/omeMeetOrgUnitContact/OmeMeetOrgUnitContactContextProvider';
import OrgUnitAthleteEntryInfoContextProvider from '../../state/orgUnitAthleteEntryInfo/OrgUnitAthleteEntryInfoContextProvider';
import OrgUnitAthleteContactContextProvider from '../../state/orgUnitAthleteContact/OrgUnitAthleteContactContextProvider';

import LeftNavModalContextProvider from '@usas/ui-web/state/leftNavModal/LeftNavModalContextProvider';
import MeetContextProvider from '@usas/ui-web/state/meet/MeetContextProvider';
import MeetFiltersContextProvider from '@usas/ui-web/state/meet/MeetFiltersContextProvider';
import SearchMeetContextProvider from '@usas/ui-web/state/searchMeet/SearchMeetContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';

import OmeEntryLoading from './omeEntryLoading/OmeEntryLoading';
import OrgUnitAdminMeetInfo from './orgUnitAdminUser/orgUnitAdminMeetInfo/OrgUnitAdminMeetInfo';
import OrgUnitAdminContactsDetail from './orgUnitAdminUser/orgUnitAdminMeetInfo/orgUnitAdminContacts/OrgUnitAdminContactsDetail';
import OrgUnitAdminRosterSelection from './orgUnitAdminUser/orgUnitAdminRosterEntries/orgUnitAdminRosterSelection/OrgUnitAdminRosterSelection';
import OrgUnitAdminRosterEntries from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntries';
import OrgUnitAdminRosterEntriesDetail from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntriesDetail';
import OrgUnitAdminRelayEntries from './orgUnitAdminUser/orgUnitAdminRelayEntries/OrgUnitAdminRelayEntries';
import OrgUnitAdminRelayEntriesTeams from './orgUnitAdminUser/orgUnitAdminRelayEntries/OrgUnitAdminRelayEntriesTeams';
import OrgUnitAdminRelayEntriesDetail from './orgUnitAdminUser/orgUnitAdminRelayEntries/OrgUnitAdminRelayEntriesDetail';
import OrgUnitAdminRelayEntriesDetailOverride from './orgUnitAdminUser/orgUnitAdminRelayEntries/OrgUnitAdminRelayEntriesDetailOverride';
import OrgUnitAdminRosterEntriesIndividualSelection from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntriesIndividualSelection';
import OrgUnitAdminRosterEntriesBonusIndividualSelection from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntriesBonusIndividualSelection';
import OrgUnitAdminRosterEntriesIndividualOverride from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntriesIndividualOverride';
import OrgUnitAdminRosterEntriesBonusIndividualOverride from './orgUnitAdminUser/orgUnitAdminRosterEntries/OrgUnitAdminRosterEntriesBonusIndividualOverride';
import OrgUnitAdminCredentials from './orgUnitAdminUser/orgUnitAdminCredentials/OrgUnitAdminCredentials';
import OrgUnitAdminCredentialsSelection from './orgUnitAdminUser/orgUnitAdminCredentials/OrgUnitAdminCredentialsSelection';
import OrgUnitAdminPurchases from './orgUnitAdminUser/orgUnitAdminPurchases/OrgUnitAdminPurchases';
import OrgUnitAdminPayments from './orgUnitAdminUser/orgUnitAdminPayments/OrgUnitAdminPayments';
import OrgUnitAdminPaymentsHQ from './orgUnitAdminUser/orgUnitAdminPayments/OrgUnitAdminPaymentsHQ';
import OrgUnitAdminReportingMyMeets from './orgUnitAdminUser/orgUnitAdminReportingMyMeets/OrgUnitAdminReportingMyMeets';

import AthleteUserContacts from './athleteUser/athleteUserContacts/AthleteUserContacts';
import AthleteUserContactsDetail from './athleteUser/athleteUserContacts/AthleteUserContactsDetail';
import AthleteUserEntriesDetail from './athleteUser/athleteUserEntries/AthleteUserEntriesDetail';
import AthleteUserEntriesIndividualSelection from './athleteUser/athleteUserEntries/AthleteUserEntriesIndividualSelection';
import AthleteUserEntriesBonusIndividualSelection from './athleteUser/athleteUserEntries/AthleteUserEntriesBonusIndividualSelection';
import AthleteUserEntriesIndividualOverride from './athleteUser/athleteUserEntries/AthleteUserEntriesIndividualOverride';
import AthleteUserEntriesBonusIndividualOverride from './athleteUser/athleteUserEntries/AthleteUserEntriesBonusIndividualOverride';
import AthleteUserCredentials from './athleteUser/athleteUserCredentials/AthleteUserCredentials';
import AthleteUserCredentialsSelection from './athleteUser/athleteUserCredentials/AthleteUserCredentialsSelection';
import AthleteUserPurchases from './athleteUser/athleteUserPurchases/AthleteUserPurchases';
import AthleteUserPayments from './athleteUser/athleteUserPayments/AthleteUserPayments';
import OUAdminEntryContextView from './orgUnitAdminUser/OUAdminEntryContextView';
import AthleteEntryContextView from './athleteUser/AthleteEntryContextView';

import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

const OUAdminEntryContextRoutes = ({ navRoutes }) => {
  return (
    <OUAdminEntryContextView>
      <Routes>
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_MEET_INFO']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_MEET_INFO']}
              editElement={<OrgUnitAdminMeetInfo />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_MEET_INFO_CONTACTS_DETAIL']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_MEET_INFO_CONTACTS_DETAIL']}
              editElement={<OrgUnitAdminContactsDetail />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_SELECTION']}
              editElement={<OrgUnitAdminRosterSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES']}
              editElement={<OrgUnitAdminRosterEntries />} />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_DETAIL']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_DETAIL']}
              editElement={<OrgUnitAdminRosterEntriesDetail />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_INDIVIDUAL_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_INDIVIDUAL_SELECTION']}
              editElement={<OrgUnitAdminRosterEntriesIndividualSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION']}
              editElement={<OrgUnitAdminRosterEntriesBonusIndividualSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE']}
              editElement={<OrgUnitAdminRosterEntriesIndividualOverride />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE']}
              editElement={<OrgUnitAdminRosterEntriesBonusIndividualOverride />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES']}
              editElement={<OrgUnitAdminRelayEntries />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_TEAMS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_TEAMS']}
              editElement={<OrgUnitAdminRelayEntriesTeams />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_DETAIL']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_DETAIL']}
              editElement={<OrgUnitAdminRelayEntriesDetail />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_DETAIL_OVERRIDE']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_RELAY_ENTRIES_DETAIL_OVERRIDE']}
              editElement={<OrgUnitAdminRelayEntriesDetailOverride />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_CREDENTIALS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_CREDENTIALS']}
              editElement={<OrgUnitAdminCredentials />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_CREDENTIALS_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_CREDENTIALS_SELECTION']}
              editElement={<OrgUnitAdminCredentialsSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_PURCHASES']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_PURCHASES']}
              editElement={<OrgUnitAdminPurchases />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_TEAM_OUA_PAYMENTS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_TEAM_OUA_PAYMENTS']}
              editElement={<OrgUnitAdminPaymentsHQ />}
              readOnlyElement={<OrgUnitAdminPayments />} />
          } />
        <Route path={navRoutes['OME_TEAMENTRY_REPORTING']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_TEAMENTRY_REPORTING']}
              editElement={<OrgUnitAdminReportingMyMeets />} />
          }
        />
        <Route path={'/'} element={<Navigate to={navRoutes['OME_ENTRY_TEAM_OUA_MEET_INFO']?.route} replace />} />
      </Routes>
    </OUAdminEntryContextView>
  )
}

const AthleteEntryContextRoutes = ({ navRoutes }) => {
  return (
    <AthleteEntryContextView>
      <Routes>
        <Route path={navRoutes['OME_ENTRY_ATHLETE_CONTACTS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_CONTACTS']}
              editElement={<AthleteUserContacts />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_CONTACTS_DETAIL']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_CONTACTS_DETAIL']}
              editElement={<AthleteUserContactsDetail />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_ENTRIES']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_ENTRIES']}
              editElement={<AthleteUserEntriesDetail />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_INDIVIDUAL_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_INDIVIDUAL_SELECTION']}
              editElement={<AthleteUserEntriesIndividualSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_BONUS_INDIVIDUAL_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_BONUS_INDIVIDUAL_SELECTION']}
              editElement={<AthleteUserEntriesBonusIndividualSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_INDIVIDUAL_OVERRIDE']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_INDIVIDUAL_OVERRIDE']}
              editElement={<AthleteUserEntriesIndividualOverride />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE']}
              editElement={<AthleteUserEntriesBonusIndividualOverride />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_CREDENTIALS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_CREDENTIALS']}
              editElement={<AthleteUserCredentials />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_CREDENTIALS_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_CREDENTIALS_SELECTION']}
              editElement={<AthleteUserCredentialsSelection />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_PURCHASES']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_PURCHASES']}
              editElement={<AthleteUserPurchases />}
            />
          }
        />
        <Route path={navRoutes['OME_ENTRY_ATHLETE_PAYMENTS']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['OME_ENTRY_ATHLETE_PAYMENTS']}
              editElement={<AthleteUserPayments />}
            />
          }
        />
        <Route path={'/'} element={<Navigate to={navRoutes['OME_ENTRY_ATHLETE_ENTRIES']?.route} replace />} />
      </Routes>
    </AthleteEntryContextView>
  )
}

const EntryRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['OME_ENTRY_LOADING']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_ENTRY_LOADING']}
            editElement={<OmeEntryLoading teamRedirectNavLink={EntryNavLinks.OU_ADMIN_MEET_INFO} athleteRedirectNavLink={EntryNavLinks.ATHLETE_CONTACTS} />} />
        }
      />
      <Route path={navRoutes['OME_ENTRY_TEAM_OUA']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_ENTRY_TEAM_OUA']}
            editElement={<OUAdminEntryContextRoutes navRoutes={navRoutes} />} />
        }
      />
      <Route path={navRoutes['OME_ENTRY_ATHLETE']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_ENTRY_ATHLETE']}
            editElement={<AthleteEntryContextRoutes navRoutes={navRoutes} />} />
        }
      />
    </Routes>
  );
};

const EntryContextProviders = ({ children }) => (
  <LeftNavModalContextProvider>
    <MeetContextProvider>
      <MeetFiltersContextProvider>
        <SearchMeetContextProvider>
          <OmeMeetOrgUnitEntryInfoContextProvider>
            <OrgUnitAthleteEntryInfoContextProvider>
              <OmeMeetOrgUnitEntryRosterPermissionsContextProvider>
                <OmeMeetContextProvider>
                  <OmeMeetEntryContextProvider>
                    <OmeMeetOrgUnitEntryContextProvider>
                      <OmeMeetTeamEntryContextProvider>
                        <OmeMeetTeamEntryFiltersContextProvider>
                          <OrgUnitAthleteEntryPurchaseContextProvider>
                            <OmeMeetOrgUnitEntryPurchaseContextProvider>
                              <OmeMeetOrgUnitAthleteEntryContextProvider>
                                <OmeMeetOrgUnitNonAthleteEntryContextProvider>
                                  <OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryContextProvider>
                                    <PersonOrgRoleContextProvider>
                                      <OmeMeetOrgUnitAthleteEntryRosterSelectionContextProvider>
                                        <OmeMeetOrgUnitContactContextProvider>
                                          <OrgGroupContextProvider>
                                            <CredentialTypeContextProvider>
                                              <OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider>
                                                <OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider>
                                                  <OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider>
                                                    <OrgUnitAthleteEntryContextIndividualRosterEntryProvider>
                                                      <OmeMeetOrgUnitAthleteEntryRelayRosterEntryContextProvider>
                                                        <OmeMeetOrgUnitAthleteEntryAggregateRelayAthleteContextProvider>
                                                          <RelayAthleteMeetEventContextProvider>
                                                            <RelayAthleteEntryTimeContextProvider>
                                                              <EventMeetEventContextProvider>
                                                                <EventMeetEventBonusContextProvider>
                                                                  <AthleteEntryContextContextProvider>
                                                                    <OUAdminEntryContextContextProvider>
                                                                      <OmeMeetOrgUnitEntryTimesContextProvider>
                                                                        <ApprovedClubsForSecondaryRepContextProvider>
                                                                          <OrgUnitAthleteContactContextProvider>
                                                                            {children}
                                                                          </OrgUnitAthleteContactContextProvider>
                                                                        </ApprovedClubsForSecondaryRepContextProvider>
                                                                      </OmeMeetOrgUnitEntryTimesContextProvider>
                                                                    </OUAdminEntryContextContextProvider>
                                                                  </AthleteEntryContextContextProvider>
                                                                </EventMeetEventBonusContextProvider>
                                                              </EventMeetEventContextProvider>
                                                            </RelayAthleteEntryTimeContextProvider>
                                                          </RelayAthleteMeetEventContextProvider>
                                                        </OmeMeetOrgUnitAthleteEntryAggregateRelayAthleteContextProvider>
                                                      </OmeMeetOrgUnitAthleteEntryRelayRosterEntryContextProvider>
                                                    </OrgUnitAthleteEntryContextIndividualRosterEntryProvider>
                                                  </OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider>
                                                </OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider>
                                              </OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider>
                                            </CredentialTypeContextProvider>
                                          </OrgGroupContextProvider>
                                        </OmeMeetOrgUnitContactContextProvider>
                                      </OmeMeetOrgUnitAthleteEntryRosterSelectionContextProvider>
                                    </PersonOrgRoleContextProvider>
                                  </OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryContextProvider>
                                </OmeMeetOrgUnitNonAthleteEntryContextProvider>
                              </OmeMeetOrgUnitAthleteEntryContextProvider>
                            </OmeMeetOrgUnitEntryPurchaseContextProvider>
                          </OrgUnitAthleteEntryPurchaseContextProvider>
                        </OmeMeetTeamEntryFiltersContextProvider>
                      </OmeMeetTeamEntryContextProvider>
                    </OmeMeetOrgUnitEntryContextProvider>
                  </OmeMeetEntryContextProvider>
                </OmeMeetContextProvider>
              </OmeMeetOrgUnitEntryRosterPermissionsContextProvider>
            </OrgUnitAthleteEntryInfoContextProvider>
          </OmeMeetOrgUnitEntryInfoContextProvider>
        </SearchMeetContextProvider>
      </MeetFiltersContextProvider>
    </MeetContextProvider>
  </LeftNavModalContextProvider>
);

const EntryContextStateAndRoutes = () => (
  <EntryContextProviders>
    <EntryRoutes />
  </EntryContextProviders>
);

export default EntryContextStateAndRoutes;